import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import CheckBlogSource from '../sources/CheckBlogSource'

@createActions(alt)
export default class CheckBlogActions {
  constructor() {
    this.generateActions(
      'setDetectingBlogUrls',
      'blogUrlsDetected'
    )
  }

  detectBlogUrls() {
    this.setDetectingBlogUrls(true)
    return CheckBlogSource.detectBlogUrls()
      .then(resp => {
        this.setDetectingBlogUrls(false)
        this.blogUrlsDetected(resp)
    })
  }
}



// WEBPACK FOOTER //
// ./app/actions/CheckBlogActions.js